import { useLayoutEffect, useRef, useState } from 'react';

interface IContentScalerProps {
  disabled?: boolean;
  width: number | null | undefined;
  children: React.ReactNode;
}

export const ContentScaler = (props: IContentScalerProps) => {
  const innerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  // Re-measure natural width whenever parent width changes
  useLayoutEffect(() => {
    if (!innerRef.current) return;

    // only scale if the observer has delivered a width > 0
    if (!props.width || props.width <= 0 || props.disabled) {
      setScale(1);

      return;
    }

    const natural = innerRef.current.scrollWidth; // unscaled width
    setScale(natural > props.width ? props.width / natural : 1);
  }, [props.width, props.disabled]);

  //
  // Main render
  //
  return (
    <div
      ref={innerRef}
      className="content-scaler"
      style={{
        transformOrigin: 'top left', // avoid centering shift
        transform: props.disabled ? undefined : `scale(${scale})`, // visual shrink
      }}
    >
      {props.children}
    </div>
  );
};
